(() => {
  'use strict';
  // Shogun and the custom hero load their own product prices after page load.
  // The head stylesheet keeps these surfaces hidden until policy is confirmed.
  const script = document.getElementById('shtff-custom-price-guards');
  const root = script?.dataset.root || '/';
  const cards = '.shg-product, a.shtx-card[href]';
  const requests = new Map();
  const checked = new WeakMap();
  let scheduled = false;

  function handleFor(card) {
    for (const data of card.querySelectorAll('script.__SHG_DATA__')) {
      try {
        const handle = JSON.parse(data.textContent).__shgProductInit?.productHandle;
        if (handle) return handle;
      } catch { /* Other page-builder data is unrelated. */ }
    }
    const href = card.matches('a[href]') ? card.href : card.querySelector('a[href*="/products/"]')?.href;
    try { return new URL(href, location.origin).pathname.match(/\/products\/([^/]+)/)?.[1]; }
    catch { return null; }
  }

  function policy(handle) {
    if (!requests.has(handle)) {
      requests.set(handle, fetch(root + 'apps/find-fit/product?handle=' + encodeURIComponent(handle), {
        credentials: 'same-origin', signal: AbortSignal.timeout(8000)
      }).then(response => {
        if (!response.ok) throw new Error('Product policy unavailable');
        return response.json();
      }).then(data => {
        if (data.product?.handle !== handle || typeof data.product.quoteOnly !== 'boolean') throw new Error('Invalid policy');
        return data.product.quoteOnly ? 'quote' : 'online';
      }).catch(() => 'unavailable'));
    }
    return requests.get(handle);
  }

  function apply(card, handle, state) {
    if (checked.get(card)?.handle !== handle || !card.isConnected) return;
    card.dataset.shtffPurchase = state;
    const previous = card.querySelector('.shtff-custom-quote');
    if (state === 'online') { previous?.remove(); return; }
    const label = previous || document.createElement(card.matches('a') ? 'span' : 'a');
    label.className = 'shtff-custom-quote';
    label.textContent = state === 'quote' ? 'Choose options & request a quote' : 'View product details';
    if (label.tagName === 'A') label.href = root + 'products/' + encodeURIComponent(handle);
    if (!previous) (card.querySelector('.shtx-card-txt') || card).appendChild(label);
  }

  function scan() {
    scheduled = false;
    for (const card of document.querySelectorAll(cards)) {
      const handle = handleFor(card);
      if (!handle) continue;
      const prior = checked.get(card);
      if (prior?.handle === handle) {
        // Page builders can replace descendants without replacing the card.
        if (prior.state !== 'online' && prior.state && !card.querySelector('.shtff-custom-quote')) apply(card, handle, prior.state);
        continue;
      }
      card.removeAttribute('data-shtff-purchase');
      card.querySelector('.shtff-custom-quote')?.remove();
      const record = {handle, state:null};
      checked.set(card, record);
      policy(handle).then(state => { record.state = state; apply(card, handle, state); });
    }
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  }
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
  scan();
})();
